var map = {
	"./juego-1.jpg": "f7dc",
	"./juego-2.jpg": "a863",
	"./juego-3.jpg": "1b64",
	"./juego-4.jpg": "c853",
	"./juego-5 - Copy.jpg": "3096",
	"./juego-5.jpg": "22b7",
	"./juego-6.jpg": "affa",
	"./juego-7.jpg": "a7e6",
	"./juego-8.jpg": "a989"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5349";